import Link from 'next/link';
import { useTranslation } from 'next-export-i18n';

import type CompanyProps from '@/types/Company.type';
import { logCustomEvent } from '@/utils/analytic';
import { AnalyticEvent } from '@/utils/enum';

import RelatedCompany from '../molecules/RelatedCompany';

type RelatedVenturesProps = {
  companies: CompanyProps[];
};

export default function RelatedVentures({ companies }: RelatedVenturesProps) {
  const { t } = useTranslation();
  // companies.sort(
  //   (a, b) => parseInt(b.founding_year, 10) - parseInt(a.founding_year, 10)
  // );

  return (
    <div className="p-5">
      <h2 className="font-bold">{t('company.relatedVentures')}</h2>
      <div className="mt-7 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {companies.map((company: CompanyProps) => (
          <Link href={`/${company.slug}`} key={company.id}>
            <a
              href={`/${company.slug}`}
              onClick={() => logCustomEvent(AnalyticEvent.ViewByRelevant)}
            >
              <RelatedCompany company={company} />
            </a>
          </Link>
        ))}
      </div>
    </div>
  );
}
